__turbopack_context__.v({
  "address": "GSU37G_address",
  "address__clear": "GSU37G_address__clear",
  "address__icon": "GSU37G_address__icon",
  "address__input": "GSU37G_address__input",
  "address__input--error": "GSU37G_address__input--error",
  "address__input--suggestions-open": "GSU37G_address__input--suggestions-open",
  "address__input-wrapper": "GSU37G_address__input-wrapper",
  "address__label": "GSU37G_address__label",
  "address__suggestion": "GSU37G_address__suggestion",
  "address__suggestion--highlighted": "GSU37G_address__suggestion--highlighted",
  "address__suggestion-icon": "GSU37G_address__suggestion-icon",
  "address__suggestion-list": "GSU37G_address__suggestion-list",
  "address__suggestion-list--open": "GSU37G_address__suggestion-list--open",
  "address__support": "GSU37G_address__support",
  "address__support-actions": "GSU37G_address__support-actions",
  "address__support-button": "GSU37G_address__support-button",
  "address__support-button-inner": "GSU37G_address__support-button-inner",
  "address__support-copy": "GSU37G_address__support-copy",
  "address__support-panel": "GSU37G_address__support-panel",
  "address__support-text": "GSU37G_address__support-text",
  "address__support-title": "GSU37G_address__support-title",
});
